import { dollarsToCents } from '@common/paymentsUtils/currencyUtils';
import errorMessages from '@common/constants/errorMessages';
import { isAllDigits, isEmpty } from '@common/paymentsUtils/inputValidator';
import { MAX_RENT_AMOUNT, MIN_RENT_AMOUNT } from '@rental-manager/constants/PaymentConstants';

const isMonthlyRentValid = (monthlyRentString: string) => {
  const monthlyRentDollarToCents = dollarsToCents(monthlyRentString);
  const monthlyRent = parseInt(monthlyRentDollarToCents, 10);

  if (isEmpty(monthlyRentString) || !isAllDigits(monthlyRentDollarToCents)) {
    return errorMessages.MONTHLY_RENT_EMPTY;
  }

  if (monthlyRent >= MIN_RENT_AMOUNT && monthlyRent <= MAX_RENT_AMOUNT) {
    return errorMessages.CLEAR_ERROR;
  }

  return errorMessages.MONTHLY_RENT_INVALID;
};

export const validateAllInputs = (ctx) => {
  const { value: monthlyRentSelected } = ctx.state;
  const errors: Array<Record<string, string>> = [];

  // validate and set all errors before returning
  const monthlyRentError = isMonthlyRentValid(monthlyRentSelected);

  if (monthlyRentError) {
    errors.push({ monthlyRent: monthlyRentError });
  }

  ctx.setState({
    error: monthlyRentError,
  });

  if (errors.length > 0) {
    ctx.props.trackValidationError({ errors });
    return false;
  }
  return true;
};

export const validatRentAmount = ({ monthlyRentSelected, setError, trackValidationError }) => {
  const errors: Array<Record<string, string>> = [];

  // validate and set all errors before returning
  const monthlyRentError = isMonthlyRentValid(monthlyRentSelected);

  if (monthlyRentError) {
    errors.push({ monthlyRent: monthlyRentError });
  }

  setError(monthlyRentError);

  if (errors.length > 0) {
    trackValidationError({ errors });
    return false;
  }
  return true;
};
